var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesCluster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 30,
    viewBox: "0 0 44 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.269956 9.18868H43.5016C43.5059 9.18868 43.5102 9.18926 43.5124 9.18868C43.6615 9.18868 43.7826 9.0577 43.7826 8.89632C43.7826 8.81739 43.7534 8.74547 43.7064 8.69284L39.3465 0.150854C39.2989 0.0578857 39.2081 0 39.1098 0H4.66175C4.5634 0 4.47261 0.0578857 4.42505 0.150854L0.0338035 8.75483C-0.0126705 8.84546 -0.0110493 8.95538 0.0375862 9.04484C0.0862218 9.1343 0.174306 9.18868 0.269956 9.18868Z",
    fill: "#ff77c8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5124 9.03467H0.270356C0.159007 9.03467 0.0590104 9.10277 0.018471 9.2071C-0.0220684 9.31088 0.00549826 9.42871 0.0876582 9.50439L21.7087 29.3384C21.7606 29.386 21.826 29.4098 21.8914 29.4098C21.9568 29.4098 22.0222 29.386 22.0741 29.3384L43.6951 9.50439C43.7773 9.42871 43.8048 9.31088 43.7643 9.2071C43.7243 9.10277 43.6232 9.03467 43.5124 9.03467Z",
    fill: "#ff77c8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesCluster);
export default __webpack_public_path__ + "static/media/services-cluster.9a422265ad9e79b168e7145db1aae961.svg";
export { ForwardRef as ReactComponent };